module.exports = __webpack_public_path__ + "media/assets/icons/circle-dollar-sign-icon-purple-249c11bede636e041b6cbe0e6e1e472c.png";